/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';
import type { EvmTokenSummaryInfo } from './EvmTokenSummaryInfo';

export type EvmErc20TransferLogInfo = {
    EVT: EvmErc20TransferLogInfo.EVT;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    TKNSINFO: EvmTokenSummaryInfo;
    QTY: string;
};

export namespace EvmErc20TransferLogInfo {

    export enum EVT {
        MINT = 'MINT',
        BURN = 'BURN',
        TRANSFER = 'TRANSFER',
    }


}

